const map = {
	"./acc-horizontal-white-new-2022.svg": 35357,
	"./acc-horizontal.svg": 56243,
	"./acc-mark.svg": 53328,
	"./account-profile.svg": 78188,
	"./add-attachment.svg": 83698,
	"./add-document.svg": 77914,
	"./alloy-alert-error.svg": 66092,
	"./alloy-alert-information.svg": 92348,
	"./alloy-alert-success.svg": 8119,
	"./alloy-alert-warning.svg": 97522,
	"./alloy-arrow-right.svg": 95589,
	"./alloy-calendar.svg": 33559,
	"./alloy-checkmark.svg": 95924,
	"./alloy-chevron-down.svg": 45463,
	"./alloy-chevron-right.svg": 6839,
	"./alloy-chevron-up.svg": 8936,
	"./alloy-close.svg": 25039,
	"./alloy-error-crane.svg": 83041,
	"./alloy-fedramp-white.svg": 43406,
	"./alloy-gear.svg": 56160,
	"./alloy-more-vertical.svg": 21513,
	"./alloy-no-data.svg": 64865,
	"./alloy-no-permission.svg": 76716,
	"./alloy-no-results.svg": 79441,
	"./alloy-pencil.svg": 69186,
	"./alloy-question-filled.svg": 3786,
	"./alloy-upload-files.svg": 28488,
	"./approve-input.svg": 12105,
	"./archive-in-filled.svg": 81470,
	"./archive-in.svg": 61093,
	"./archive-neutral-filled.svg": 32446,
	"./archive-neutral.svg": 14885,
	"./archive-out-filled.svg": 19681,
	"./archive-out.svg": 69340,
	"./archived.svg": 59889,
	"./attachment-icon.svg": 93770,
	"./attachment.svg": 31176,
	"./attachments-icon.svg": 56223,
	"./back-arrow.svg": 71418,
	"./bim360-mark.svg": 53244,
	"./bread-crumb-arrow.svg": 72253,
	"./calendar-big.svg": 25144,
	"./calendar.svg": 15597,
	"./camera-icon.svg": 80436,
	"./cancel-input-round.svg": 33453,
	"./cancel-input.svg": 482,
	"./check-icn-checkbox.svg": 42838,
	"./check-icn.svg": 35972,
	"./check.svg": 4053,
	"./circle.svg": 13507,
	"./circular-add.svg": 55358,
	"./close-rounded-icon.svg": 81197,
	"./cog-big.svg": 40349,
	"./cog-small.svg": 39586,
	"./comments-icon.svg": 48393,
	"./company-icon.svg": 32414,
	"./cone.svg": 33062,
	"./create-another.svg": 82689,
	"./doc-available.svg": 27985,
	"./doc-not-available.svg": 6877,
	"./doctype-3ds.svg": 36284,
	"./doctype-archive.svg": 63002,
	"./doctype-audio.svg": 35622,
	"./doctype-docx.svg": 33998,
	"./doctype-dotx.svg": 27687,
	"./doctype-dwf.svg": 75951,
	"./doctype-dwfx.svg": 17989,
	"./doctype-dwg.svg": 32222,
	"./doctype-exchange.svg": 42855,
	"./doctype-extract-failure.svg": 1642,
	"./doctype-f3d.svg": 91647,
	"./doctype-file.svg": 23202,
	"./doctype-idw.svg": 84010,
	"./doctype-ifc.svg": 45484,
	"./doctype-image.svg": 51207,
	"./doctype-iwm.svg": 25289,
	"./doctype-mat.svg": 69646,
	"./doctype-max.svg": 38266,
	"./doctype-maxc.svg": 16693,
	"./doctype-mcr.svg": 14230,
	"./doctype-ms.svg": 15772,
	"./doctype-mxp.svg": 85589,
	"./doctype-nwc.svg": 38044,
	"./doctype-nwd.svg": 35971,
	"./doctype-obj.svg": 53071,
	"./doctype-odp.svg": 80475,
	"./doctype-ods.svg": 99112,
	"./doctype-odt.svg": 18919,
	"./doctype-pdf-native.svg": 8682,
	"./doctype-pdf.svg": 6842,
	"./doctype-potx.svg": 71523,
	"./doctype-ppsx.svg": 64305,
	"./doctype-ppt.svg": 76108,
	"./doctype-pptx.svg": 62236,
	"./doctype-process-suspend.svg": 59868,
	"./doctype-processing.svg": 78449,
	"./doctype-rvt.svg": 5036,
	"./doctype-sheet.svg": 753,
	"./doctype-textfile.svg": 62707,
	"./doctype-video.svg": 72529,
	"./doctype-vsdx.svg": 60869,
	"./doctype-vssx.svg": 37864,
	"./doctype-vstx.svg": 4021,
	"./doctype-xls.svg": 19639,
	"./doctype-xlsm.svg": 79312,
	"./doctype-xlsx.svg": 41357,
	"./doctype-xltx.svg": 81568,
	"./document-icon.svg": 63814,
	"./download-icon.svg": 87175,
	"./drag-icon.svg": 37813,
	"./edit-icon-outline.svg": 32810,
	"./edit-icon.svg": 87823,
	"./empty-box.svg": 30354,
	"./empty-template.svg": 17197,
	"./error-icon.svg": 76911,
	"./exclamation.svg": 56434,
	"./export-external.svg": 83435,
	"./export.svg": 26673,
	"./first-time-use.svg": 64969,
	"./folder-icon.svg": 4619,
	"./folder-plans-icon.svg": 11746,
	"./folder-project-icon.svg": 57555,
	"./frozen-left.svg": 9781,
	"./frozen-right.svg": 14904,
	"./funnel-icon.svg": 28903,
	"./help-icon.svg": 93216,
	"./icon-avatar-menu.svg": 65130,
	"./icon-block.svg": 15000,
	"./icon-check.svg": 19043,
	"./icon-custom-attribute-multi-select.svg": 14540,
	"./icon-custom-attribute-numeric.svg": 3829,
	"./icon-custom-attribute-paragraph.svg": 75326,
	"./icon-custom-attribute-single-select.svg": 65189,
	"./icon-custom-attribute-text.svg": 93585,
	"./icon-star.svg": 73801,
	"./image-error-icn.svg": 4114,
	"./image-placeholder.svg": 93894,
	"./info-circle-small.svg": 35806,
	"./info-circle.svg": 3420,
	"./lock.svg": 84286,
	"./logo.svg": 61814,
	"./magnifying-glass.svg": 85479,
	"./maintenance-error-image.svg": 27697,
	"./malware-icon.svg": 78101,
	"./matrix-header-title-triangle.svg": 46576,
	"./menu-arrow.svg": 89458,
	"./mobile-logo.svg": 58027,
	"./modal-close.svg": 38261,
	"./module-picker.svg": 41310,
	"./more.svg": 67744,
	"./navigation-arrow.svg": 96485,
	"./no-permissions.svg": 76657,
	"./no-projects.svg": 91221,
	"./not-found.svg": 50573,
	"./private.svg": 47500,
	"./project-profile.svg": 54198,
	"./published.svg": 56099,
	"./remove-document.svg": 12403,
	"./reset-small.svg": 54978,
	"./role-icon.svg": 49543,
	"./scroll-to-button-arrow.svg": 73187,
	"./settings.svg": 78824,
	"./success-icon.svg": 26946,
	"./table-arrow.svg": 32569,
	"./three-dots-menu.svg": 37698,
	"./tick.svg": 54020,
	"./trash-filled.svg": 24096,
	"./trash.svg": 85503,
	"./upload-files.svg": 19942,
	"./upload-icon.svg": 37086,
	"./warning-icon.svg": 99441,
	"@adsk/bim360-matrix-react-assets/es/acc-horizontal-white-new-2022.svg": 35357,
	"@adsk/bim360-matrix-react-assets/es/acc-horizontal.svg": 56243,
	"@adsk/bim360-matrix-react-assets/es/acc-mark.svg": 53328,
	"@adsk/bim360-matrix-react-assets/es/account-profile.svg": 78188,
	"@adsk/bim360-matrix-react-assets/es/add-attachment.svg": 83698,
	"@adsk/bim360-matrix-react-assets/es/add-document.svg": 77914,
	"@adsk/bim360-matrix-react-assets/es/alloy-alert-error.svg": 66092,
	"@adsk/bim360-matrix-react-assets/es/alloy-alert-information.svg": 92348,
	"@adsk/bim360-matrix-react-assets/es/alloy-alert-success.svg": 8119,
	"@adsk/bim360-matrix-react-assets/es/alloy-alert-warning.svg": 97522,
	"@adsk/bim360-matrix-react-assets/es/alloy-arrow-right.svg": 95589,
	"@adsk/bim360-matrix-react-assets/es/alloy-calendar.svg": 33559,
	"@adsk/bim360-matrix-react-assets/es/alloy-checkmark.svg": 95924,
	"@adsk/bim360-matrix-react-assets/es/alloy-chevron-down.svg": 45463,
	"@adsk/bim360-matrix-react-assets/es/alloy-chevron-right.svg": 6839,
	"@adsk/bim360-matrix-react-assets/es/alloy-chevron-up.svg": 8936,
	"@adsk/bim360-matrix-react-assets/es/alloy-close.svg": 25039,
	"@adsk/bim360-matrix-react-assets/es/alloy-error-crane.svg": 83041,
	"@adsk/bim360-matrix-react-assets/es/alloy-fedramp-white.svg": 43406,
	"@adsk/bim360-matrix-react-assets/es/alloy-gear.svg": 56160,
	"@adsk/bim360-matrix-react-assets/es/alloy-more-vertical.svg": 21513,
	"@adsk/bim360-matrix-react-assets/es/alloy-no-data.svg": 64865,
	"@adsk/bim360-matrix-react-assets/es/alloy-no-permission.svg": 76716,
	"@adsk/bim360-matrix-react-assets/es/alloy-no-results.svg": 79441,
	"@adsk/bim360-matrix-react-assets/es/alloy-pencil.svg": 69186,
	"@adsk/bim360-matrix-react-assets/es/alloy-question-filled.svg": 3786,
	"@adsk/bim360-matrix-react-assets/es/alloy-upload-files.svg": 28488,
	"@adsk/bim360-matrix-react-assets/es/approve-input.svg": 12105,
	"@adsk/bim360-matrix-react-assets/es/archive-in-filled.svg": 81470,
	"@adsk/bim360-matrix-react-assets/es/archive-in.svg": 61093,
	"@adsk/bim360-matrix-react-assets/es/archive-neutral-filled.svg": 32446,
	"@adsk/bim360-matrix-react-assets/es/archive-neutral.svg": 14885,
	"@adsk/bim360-matrix-react-assets/es/archive-out-filled.svg": 19681,
	"@adsk/bim360-matrix-react-assets/es/archive-out.svg": 69340,
	"@adsk/bim360-matrix-react-assets/es/archived.svg": 59889,
	"@adsk/bim360-matrix-react-assets/es/attachment-icon.svg": 93770,
	"@adsk/bim360-matrix-react-assets/es/attachment.svg": 31176,
	"@adsk/bim360-matrix-react-assets/es/attachments-icon.svg": 56223,
	"@adsk/bim360-matrix-react-assets/es/back-arrow.svg": 71418,
	"@adsk/bim360-matrix-react-assets/es/bim360-mark.svg": 53244,
	"@adsk/bim360-matrix-react-assets/es/bread-crumb-arrow.svg": 72253,
	"@adsk/bim360-matrix-react-assets/es/calendar-big.svg": 25144,
	"@adsk/bim360-matrix-react-assets/es/calendar.svg": 15597,
	"@adsk/bim360-matrix-react-assets/es/camera-icon.svg": 80436,
	"@adsk/bim360-matrix-react-assets/es/cancel-input-round.svg": 33453,
	"@adsk/bim360-matrix-react-assets/es/cancel-input.svg": 482,
	"@adsk/bim360-matrix-react-assets/es/check-icn-checkbox.svg": 42838,
	"@adsk/bim360-matrix-react-assets/es/check-icn.svg": 35972,
	"@adsk/bim360-matrix-react-assets/es/check.svg": 4053,
	"@adsk/bim360-matrix-react-assets/es/circle.svg": 13507,
	"@adsk/bim360-matrix-react-assets/es/circular-add.svg": 55358,
	"@adsk/bim360-matrix-react-assets/es/close-rounded-icon.svg": 81197,
	"@adsk/bim360-matrix-react-assets/es/cog-big.svg": 40349,
	"@adsk/bim360-matrix-react-assets/es/cog-small.svg": 39586,
	"@adsk/bim360-matrix-react-assets/es/comments-icon.svg": 48393,
	"@adsk/bim360-matrix-react-assets/es/company-icon.svg": 32414,
	"@adsk/bim360-matrix-react-assets/es/cone.svg": 33062,
	"@adsk/bim360-matrix-react-assets/es/create-another.svg": 82689,
	"@adsk/bim360-matrix-react-assets/es/doc-available.svg": 27985,
	"@adsk/bim360-matrix-react-assets/es/doc-not-available.svg": 6877,
	"@adsk/bim360-matrix-react-assets/es/doctype-3ds.svg": 36284,
	"@adsk/bim360-matrix-react-assets/es/doctype-archive.svg": 63002,
	"@adsk/bim360-matrix-react-assets/es/doctype-audio.svg": 35622,
	"@adsk/bim360-matrix-react-assets/es/doctype-docx.svg": 33998,
	"@adsk/bim360-matrix-react-assets/es/doctype-dotx.svg": 27687,
	"@adsk/bim360-matrix-react-assets/es/doctype-dwf.svg": 75951,
	"@adsk/bim360-matrix-react-assets/es/doctype-dwfx.svg": 17989,
	"@adsk/bim360-matrix-react-assets/es/doctype-dwg.svg": 32222,
	"@adsk/bim360-matrix-react-assets/es/doctype-exchange.svg": 42855,
	"@adsk/bim360-matrix-react-assets/es/doctype-extract-failure.svg": 1642,
	"@adsk/bim360-matrix-react-assets/es/doctype-f3d.svg": 91647,
	"@adsk/bim360-matrix-react-assets/es/doctype-file.svg": 23202,
	"@adsk/bim360-matrix-react-assets/es/doctype-idw.svg": 84010,
	"@adsk/bim360-matrix-react-assets/es/doctype-ifc.svg": 45484,
	"@adsk/bim360-matrix-react-assets/es/doctype-image.svg": 51207,
	"@adsk/bim360-matrix-react-assets/es/doctype-iwm.svg": 25289,
	"@adsk/bim360-matrix-react-assets/es/doctype-mat.svg": 69646,
	"@adsk/bim360-matrix-react-assets/es/doctype-max.svg": 38266,
	"@adsk/bim360-matrix-react-assets/es/doctype-maxc.svg": 16693,
	"@adsk/bim360-matrix-react-assets/es/doctype-mcr.svg": 14230,
	"@adsk/bim360-matrix-react-assets/es/doctype-ms.svg": 15772,
	"@adsk/bim360-matrix-react-assets/es/doctype-mxp.svg": 85589,
	"@adsk/bim360-matrix-react-assets/es/doctype-nwc.svg": 38044,
	"@adsk/bim360-matrix-react-assets/es/doctype-nwd.svg": 35971,
	"@adsk/bim360-matrix-react-assets/es/doctype-obj.svg": 53071,
	"@adsk/bim360-matrix-react-assets/es/doctype-odp.svg": 80475,
	"@adsk/bim360-matrix-react-assets/es/doctype-ods.svg": 99112,
	"@adsk/bim360-matrix-react-assets/es/doctype-odt.svg": 18919,
	"@adsk/bim360-matrix-react-assets/es/doctype-pdf-native.svg": 8682,
	"@adsk/bim360-matrix-react-assets/es/doctype-pdf.svg": 6842,
	"@adsk/bim360-matrix-react-assets/es/doctype-potx.svg": 71523,
	"@adsk/bim360-matrix-react-assets/es/doctype-ppsx.svg": 64305,
	"@adsk/bim360-matrix-react-assets/es/doctype-ppt.svg": 76108,
	"@adsk/bim360-matrix-react-assets/es/doctype-pptx.svg": 62236,
	"@adsk/bim360-matrix-react-assets/es/doctype-process-suspend.svg": 59868,
	"@adsk/bim360-matrix-react-assets/es/doctype-processing.svg": 78449,
	"@adsk/bim360-matrix-react-assets/es/doctype-rvt.svg": 5036,
	"@adsk/bim360-matrix-react-assets/es/doctype-sheet.svg": 753,
	"@adsk/bim360-matrix-react-assets/es/doctype-textfile.svg": 62707,
	"@adsk/bim360-matrix-react-assets/es/doctype-video.svg": 72529,
	"@adsk/bim360-matrix-react-assets/es/doctype-vsdx.svg": 60869,
	"@adsk/bim360-matrix-react-assets/es/doctype-vssx.svg": 37864,
	"@adsk/bim360-matrix-react-assets/es/doctype-vstx.svg": 4021,
	"@adsk/bim360-matrix-react-assets/es/doctype-xls.svg": 19639,
	"@adsk/bim360-matrix-react-assets/es/doctype-xlsm.svg": 79312,
	"@adsk/bim360-matrix-react-assets/es/doctype-xlsx.svg": 41357,
	"@adsk/bim360-matrix-react-assets/es/doctype-xltx.svg": 81568,
	"@adsk/bim360-matrix-react-assets/es/document-icon.svg": 63814,
	"@adsk/bim360-matrix-react-assets/es/download-icon.svg": 87175,
	"@adsk/bim360-matrix-react-assets/es/drag-icon.svg": 37813,
	"@adsk/bim360-matrix-react-assets/es/edit-icon-outline.svg": 32810,
	"@adsk/bim360-matrix-react-assets/es/edit-icon.svg": 87823,
	"@adsk/bim360-matrix-react-assets/es/empty-box.svg": 30354,
	"@adsk/bim360-matrix-react-assets/es/empty-template.svg": 17197,
	"@adsk/bim360-matrix-react-assets/es/error-icon.svg": 76911,
	"@adsk/bim360-matrix-react-assets/es/exclamation.svg": 56434,
	"@adsk/bim360-matrix-react-assets/es/export-external.svg": 83435,
	"@adsk/bim360-matrix-react-assets/es/export.svg": 26673,
	"@adsk/bim360-matrix-react-assets/es/first-time-use.svg": 64969,
	"@adsk/bim360-matrix-react-assets/es/folder-icon.svg": 4619,
	"@adsk/bim360-matrix-react-assets/es/folder-plans-icon.svg": 11746,
	"@adsk/bim360-matrix-react-assets/es/folder-project-icon.svg": 57555,
	"@adsk/bim360-matrix-react-assets/es/frozen-left.svg": 9781,
	"@adsk/bim360-matrix-react-assets/es/frozen-right.svg": 14904,
	"@adsk/bim360-matrix-react-assets/es/funnel-icon.svg": 28903,
	"@adsk/bim360-matrix-react-assets/es/help-icon.svg": 93216,
	"@adsk/bim360-matrix-react-assets/es/icon-avatar-menu.svg": 65130,
	"@adsk/bim360-matrix-react-assets/es/icon-block.svg": 15000,
	"@adsk/bim360-matrix-react-assets/es/icon-check.svg": 19043,
	"@adsk/bim360-matrix-react-assets/es/icon-custom-attribute-multi-select.svg": 14540,
	"@adsk/bim360-matrix-react-assets/es/icon-custom-attribute-numeric.svg": 3829,
	"@adsk/bim360-matrix-react-assets/es/icon-custom-attribute-paragraph.svg": 75326,
	"@adsk/bim360-matrix-react-assets/es/icon-custom-attribute-single-select.svg": 65189,
	"@adsk/bim360-matrix-react-assets/es/icon-custom-attribute-text.svg": 93585,
	"@adsk/bim360-matrix-react-assets/es/icon-star.svg": 73801,
	"@adsk/bim360-matrix-react-assets/es/image-error-icn.svg": 4114,
	"@adsk/bim360-matrix-react-assets/es/image-placeholder.svg": 93894,
	"@adsk/bim360-matrix-react-assets/es/info-circle-small.svg": 35806,
	"@adsk/bim360-matrix-react-assets/es/info-circle.svg": 3420,
	"@adsk/bim360-matrix-react-assets/es/lock.svg": 84286,
	"@adsk/bim360-matrix-react-assets/es/logo.svg": 61814,
	"@adsk/bim360-matrix-react-assets/es/magnifying-glass.svg": 85479,
	"@adsk/bim360-matrix-react-assets/es/maintenance-error-image.svg": 27697,
	"@adsk/bim360-matrix-react-assets/es/malware-icon.svg": 78101,
	"@adsk/bim360-matrix-react-assets/es/matrix-header-title-triangle.svg": 46576,
	"@adsk/bim360-matrix-react-assets/es/menu-arrow.svg": 89458,
	"@adsk/bim360-matrix-react-assets/es/mobile-logo.svg": 58027,
	"@adsk/bim360-matrix-react-assets/es/modal-close.svg": 38261,
	"@adsk/bim360-matrix-react-assets/es/module-picker.svg": 41310,
	"@adsk/bim360-matrix-react-assets/es/more.svg": 67744,
	"@adsk/bim360-matrix-react-assets/es/navigation-arrow.svg": 96485,
	"@adsk/bim360-matrix-react-assets/es/no-permissions.svg": 76657,
	"@adsk/bim360-matrix-react-assets/es/no-projects.svg": 91221,
	"@adsk/bim360-matrix-react-assets/es/not-found.svg": 50573,
	"@adsk/bim360-matrix-react-assets/es/private.svg": 47500,
	"@adsk/bim360-matrix-react-assets/es/project-profile.svg": 54198,
	"@adsk/bim360-matrix-react-assets/es/published.svg": 56099,
	"@adsk/bim360-matrix-react-assets/es/remove-document.svg": 12403,
	"@adsk/bim360-matrix-react-assets/es/reset-small.svg": 54978,
	"@adsk/bim360-matrix-react-assets/es/role-icon.svg": 49543,
	"@adsk/bim360-matrix-react-assets/es/scroll-to-button-arrow.svg": 73187,
	"@adsk/bim360-matrix-react-assets/es/settings.svg": 78824,
	"@adsk/bim360-matrix-react-assets/es/success-icon.svg": 26946,
	"@adsk/bim360-matrix-react-assets/es/table-arrow.svg": 32569,
	"@adsk/bim360-matrix-react-assets/es/three-dots-menu.svg": 37698,
	"@adsk/bim360-matrix-react-assets/es/tick.svg": 54020,
	"@adsk/bim360-matrix-react-assets/es/trash-filled.svg": 24096,
	"@adsk/bim360-matrix-react-assets/es/trash.svg": 85503,
	"@adsk/bim360-matrix-react-assets/es/upload-files.svg": 19942,
	"@adsk/bim360-matrix-react-assets/es/upload-icon.svg": 37086,
	"@adsk/bim360-matrix-react-assets/es/warning-icon.svg": 99441
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60771;